import { LOGIN_USER } from './mixpanelEventNames';

//change value from false to true to disable mixpanel
const isDisabled: boolean = !(
    process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN !== 'false' &&
    Boolean(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN) &&
    Boolean(process.env.REACT_APP_MIXPANEL_BACKEND_URL)
);
// export const initMixpanel = (): void => {
//     const projectToken: string | undefined = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;
//     if (typeof window === 'undefined' || !projectToken || isDisabled) return;
//     mixpanel.init(projectToken);
//     const isAuthenticated: boolean = JSON.parse(localStorage.getItem('isAuthenticated') || 'false');
//     const oktaParsedObj = JSON.parse(localStorage.getItem('okta-token-storage') || '{}');
//     const userDetails = oktaParsedObj?.idToken?.claims;
//     const userEmail = userDetails?.email || localStorage.getItem('email') || '';
//     const isLoginButtonClicked: boolean = JSON.parse(localStorage.getItem('login_clicked') || 'false');
//     //check if user is authenticated
//     //if yes, identify user,set user profile and track login event in mixpanel
//     if (isAuthenticated && userEmail) {
//         identifyUserMixpanel(userEmail);
//         setUserProfileMixpanel(userEmail, userDetails?.name);

//         //only track login event when user clicks on login button.
//         if (isLoginButtonClicked) {
//             trackEventMixpanel(LOGIN_USER, { email: userEmail });
//             localStorage.removeItem('login_clicked'); //remove local storage item to avoid multiple events being triggered
//         }
//     }
//     // console.log(projectToken, publicRuntimeConfig, 'logging project');
// };

//function to identify user in mixpanel
// export const identifyUserMixpanel = (email: string = ''): void => {
//     if (!email || !mixpanel || isDisabled) return;
//     mixpanel.identify(email);
// };

// //function to set user profile in mixpanel
export const setUserProfileMixpanel = (name: string = 'User') => {
    const userId = localStorage.getItem('email');
    if (!userId || isDisabled) return;
    const mixpanelBackendUrl = process.env.REACT_APP_MIXPANEL_BACKEND_URL;
    const projectToken: string | undefined = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;
    const accessToken = localStorage.getItem('accessToken') || '';
    const osName = fetchOsInfo(navigator.userAgent);
    const browserName = fetchBrowserInfo(navigator.userAgent);
    const body = {
        user_id: userId,
        profile_params: {
            $email: userId,
            $name: name,
            $os: osName,
            $browser: browserName,
        },
        mix_panel_project_id: projectToken,
        token: `Bearer ${accessToken}`,
    };
    fetch(`${mixpanelBackendUrl}/set-user-profile`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'content-type': 'application/json' },
    });

    // mixpanel.people.set({
    //     name,
    //     $email: email,
    // });
};

//function to track events
export const trackEventMixpanel = (eventName: string, eventProperty: Object = {}): void => {
    const userId = localStorage.getItem('email');
    if (!eventName || isDisabled || !userId) return;
    const mixpanelBackendUrl = process.env.REACT_APP_MIXPANEL_BACKEND_URL;

    const projectToken: string | undefined = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;
    const accessToken = localStorage.getItem('accessToken') || '';

    const osName = fetchOsInfo(navigator.userAgent);
    const browserName = fetchBrowserInfo(navigator.userAgent);
    const body = {
        user_id: userId,
        event_name: eventName,
        client_id: 1, //remove it later from backend
        event: {
            $os: osName,
            $current_url: window.location.href,
            $user_id: userId,
            $browser: browserName,
            $screen_height: [window.innerHeight, window.outerHeight],
            $screen_width: [window.innerWidth, window.outerWidth],
            ...eventProperty,
        },
        mix_panel_project_id: projectToken,
        token: `Bearer ${accessToken}`,
    };
    fetch(`${mixpanelBackendUrl}/send_user_events`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'content-type': 'application/json' },
    });

    // mixpanel.track(eventName, { ...eventProperty });
};

function fetchOsInfo(userAgent: string) {
    let osName = userAgent;
    if (userAgent.indexOf('Win') != -1) return (osName = 'Windows');
    if (userAgent.indexOf('Mac') != -1) return (osName = 'Mac OS X');
    if (userAgent.indexOf('X11') != -1) return (osName = 'UNIX');
    if (userAgent.indexOf('Linux') != -1) return (osName = 'Linux');
    return osName;
}

function fetchBrowserInfo(userAgent: string) {
    let browserName = userAgent;
    // In Opera, the true version is after "OPR" or after "Version"
    if (userAgent.indexOf('OPR') != -1) {
        return (browserName = 'Opera');
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    if (userAgent.indexOf('Edg') != -1) {
        return (browserName = 'Microsoft Edge');
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    if (userAgent.indexOf('MSIE') != -1) {
        return (browserName = 'Microsoft Internet Explorer');
    }
    // In Chrome, the true version is after "Chrome"
    if (userAgent.indexOf('Chrome') != -1) {
        return (browserName = 'Chrome');
    }
    // In Safari, the true version is after "Safari" or after "Version"
    if (userAgent.indexOf('Safari') != -1) {
        return (browserName = 'Safari');
    }
    // In Firefox, the true version is after "Firefox"
    if (userAgent.indexOf('Firefox') != -1) {
        return (browserName = 'Firefox');
    }
    return browserName;
}
